var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-results d-flex flex-column justify-content-center align-items-center p-5 w-100"},[_c('h3',{staticClass:"my-5 fw-bold"},[_vm._v(_vm._s(_vm.$t('noResults')))])])}
var staticRenderFns = []

export { render, staticRenderFns }